<script context="module">
	import { z } from "zod";
	export const name = "Text";
	export const CustomFields = z.object({
		show_summary: z.boolean().optional(),
	});
</script>

<script>
	import Kicker from "./Kicker.svelte";
	import Stamp from "./Stamp.svelte";

	export let data = {};
	export let id = undefined;
	export let type = undefined;
	export let indexInContainer = undefined;
	id || type || indexInContainer;

	$: content = data && data.content;
	$: cf = (data && data.custom_fields) || {};
	$: showSummary = cf.show_summary !== false;
</script>

{#if content}
	<article class="af-card af-item af-item--text">
		<div class="af-card__body">
			<Kicker {content} />
			<h3 class="af-card__title"><a href={content.url}>{content.title}</a></h3>
			{#if showSummary && content.summary}
				<p class="af-card__summary">{content.summary}</p>
			{/if}
			<Stamp {content} />
		</div>
	</article>
{/if}

<style lang="scss">
	@use "../../styles/mixins" as m;

	.af-card {
		@include m.af-card;
	}

	.af-card__body {
		display: flex;
		flex-direction: column;
		gap: var(--af-space-2);
		padding: var(--af-space-6);
		flex: 1 1 auto;
	}

	.af-card__title {
		font: 600 var(--af-text-h3) / var(--af-leading-tight) var(--af-font-serif);
		color: var(--af-ink);
		text-wrap: balance;

		a {
			@include m.af-stretched-link;
			@include m.af-clamp(4);
		}
	}

	.af-card__summary {
		font-size: var(--af-text-body-sm);
		line-height: 1.5;
		color: var(--af-ink-muted);
		@include m.af-clamp(3);
	}

	.af-card :global(.af-item__stamp) {
		margin-top: auto;
		padding-top: var(--af-space-2);
	}
</style>
